import React from 'react'
import { Button, CountdownButton } from '../../elementals'
import { CoreButtonProps } from 'src/components/elementals/countdownButton'

export interface ActionModalButtonProps extends CoreButtonProps {
  label: string
  style?: React.CSSProperties
  isCountdownButton?: boolean
  reInitialize?: boolean
}

export const ActionModalButton = ({
  isCountdownButton,
  label,
  disabled,
  loading,
  ...rest
}: ActionModalButtonProps) =>
  isCountdownButton ? (
    <CountdownButton
      {...rest}
      seconds={5}
      disabled={disabled || loading}
      loading={loading}
    >
      {label}
    </CountdownButton>
  ) : (
    <Button {...rest} disabled={disabled || loading}>
      {label}
    </Button>
  )
